/* Public shared report — no authentication required. Fetched via /api/reports/shared/:token. */

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import ReportRenderer from "../components/ReportRenderer";
import "./ReportHistory.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharedReport() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/reports/shared/${token}`);
        setState({ loading: false, data: r.data, error: null });
      } catch (e) {
        setState({
          loading: false, data: null,
          error: e.response?.data?.detail || "This shared report is unavailable.",
        });
      }
    })();
  }, [token]);

  if (state.loading) {
    return (
      <div className="rc">
        <div className="rc-loading" data-testid="shared-report-loading">
          <Loader2 size={18} className="rc-spin" /> Loading report…
        </div>
      </div>
    );
  }
  if (state.error) {
    return (
      <div className="rc">
        <div className="rc-empty" data-testid="shared-report-error">
          <h2>Report unavailable</h2>
          <p>{state.error}</p>
        </div>
      </div>
    );
  }

  const { report, meta } = state.data || {};
  const product = meta?.product || "sundaybuilder";
  const rmeta = { church: meta?.church, title: meta?.title };

  return (
    <div className="rc" data-testid="shared-report">
      <header className="rc-top">
        <div className="rc-top-l">
          <div>
            <h1 className="rc-title" style={{ fontSize: 22 }}>Shared Report</h1>
            <p className="rc-sub">Read-only · shared from Liturgical Intelligence™</p>
          </div>
        </div>
      </header>
      <main className="rc-body" style={{ maxWidth: 900 }}>
        <ReportRenderer report={report} meta={rmeta} product={product} />
      </main>
    </div>
  );
}
